import React from 'react';
import cx from 'classnames';
import { Grid } from '../Grid';
import { main, padded } from './MainCL.module.scss';

const MainCL = (props) => (
  <Grid
    className={cx(main, {
      [padded]: props.padded,
    })}
    {...props}
  />
);

export default MainCL;